import Sha256 from "./sha256";
import yupTypeValidator from "./YupTypeValidator";
import * as yup from "yup";

export const generateFormikObject = (fields = []) => {
  let initialObject = {};
  let initialObjectValidation = {};
  if (fields) {
    fields.forEach((item) => {
      initialObject[item.FieldName] = item.value;
      if (item.Required) {
        initialObjectValidation[item.FieldName] = yupTypeValidator(item);
      }
    });
  }
  return { initialValues: initialObject, validationSchema: yup.object(initialObjectValidation) };
};

export const GenerateObjectVersion = (obj = {}, fields = []) => {
  let objSPVersion = "";
  fields.forEach((item) => {

    if (item.ReadOnly || item.HtmlType === "separator") return;

    if (item.HtmlType === "date") {
      if (obj[item.FieldName] === 'Invalid date') {
        obj[item.FieldName] = null;
      }
    }

    if (item.HtmlType !== "separator") {
      objSPVersion +=
        (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
    }
    if (
      item.FieldType === "int" ||
      item.FieldType === "bool" ||
      item.FieldType === "bit" ||
      item.FieldType === "bigint"
    ) {
      objSPVersion +=
        obj[item.FieldName] === undefined || obj[item.FieldName] === null || obj[item.FieldName] === "null" || obj[item.FieldName] === ""
          ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
          : obj[item.FieldName] ?? "null";

    } else if (item.HtmlType === "password") {
      let passwordEncrypted = null;
      if (obj[item.FieldName] && obj[item.FieldName].length > 0) {
        passwordEncrypted =
          obj["UserName"].toUpperCase() + obj[item.FieldName];
        passwordEncrypted = Sha256.hash(passwordEncrypted);
        ;
      }
      objSPVersion +=
        obj[item.FieldName] === undefined
          ? "null"
          : "'" + passwordEncrypted + "'"
    } else
      if (item.HtmlType === 'radio') {

        objSPVersion +=
          obj[item.FieldName] === undefined || obj[item.FieldName] === null
            ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
            : "'" + obj[item.FieldName] + "'";
      } else if (item.HtmlType === 'checkbox') {
        objSPVersion +=
          obj[item.FieldName] === undefined || obj[item.FieldName] === null
            ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
            : obj[item.FieldName] === true ? "1" : "0";
      } else {
        objSPVersion +=
          obj[item.FieldName] === undefined || obj[item.FieldName] === null
            ? "null"
            : "'" + obj[item.FieldName] + "'";
      }
  });

  return objSPVersion;
}